export enum RewardLevel {
  Starter = 'Starter',
  Rising = 'Rising Star',
  Super = 'Super Star',
  Legend = 'Legend',
}

export const RewardsLevels = [
  {
    name: RewardLevel.Starter,
    minimum: 0
  },
  {
    name: RewardLevel.Rising,
    minimum: 34
  },
  {
    name: RewardLevel.Super,
    minimum: 64
  },
  {
    name: RewardLevel.Legend,
    minimum: 94
  }
].reverse();

export const getCurrentLevel = (num: number) => {
  for (let level of RewardsLevels) {
    if (num >= level.minimum) {
      return level.name;
    }
  }

  return RewardLevel.Starter;
}

export const getNextLevel = (num: number) => {
  let nextLevel = null;

  for (let level of RewardsLevels) {
    if (level.minimum <= num && nextLevel && nextLevel.minimum >= num) {
      return nextLevel;
    }

    nextLevel = level;
  }

  return RewardsLevels[0];
}